import fetchManager from '@utils/fetchManager'
import { urlQueryData, getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");

export default {
  getAllCompanies: async (querys) => {
    const url = urlQueryData(`${API_URL}/CatalogueManagement/api/amx/cpe/companies`, querys)
    const response = await fetchManager(url)
    return response
  },
  updateStatusCompany: async (id, data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/companies/status/${id}`, {
        method: 'PATCH',
        data,
      })
    return response
  },
  addCompany: async (data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/companies`, {
        method: 'POST',
        data,
      })
    return response
  },
  editCompany: async (data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/companies`, {
        method: 'PUT',
        data,
      })
    return response
  },
}